import { render, staticRenderFns } from "./UploadRealization.vue?vue&type=template&id=5a5210d3&scoped=true&"
import script from "./UploadRealization.vue?vue&type=script&lang=js&"
export * from "./UploadRealization.vue?vue&type=script&lang=js&"
import style1 from "./UploadRealization.vue?vue&type=style&index=1&id=5a5210d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5210d3",
  null
  
)

export default component.exports